module.exports = __webpack_public_path__ + "static/media/makeover_home_banner.4ecce514.jpg";